import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import { providerLeadsApi } from "rdx/modules/projects/endpoints";
import { PROJECT_TAGS } from "rdx/modules/projects/tags";
import messages from "../messages";

function* requestAdminVisionProposal(action) {
  const { id, requestType, listView, proposalNotes, cloneId, displayName, designTool, requestedTurnaround, product } =
    action.payload;
  const { success, data, error } = yield* makeRequest.post(`/projects/${id}/request_vision_proposal`, {
    id,
    request_type: requestType || "over-night",
    proposal_notes: proposalNotes,
    clone_id: cloneId,
    display_name: displayName,
    design_tool: designTool,
    requested_turnaround: requestedTurnaround,
    product,
  });

  if (success && data && !data.body?.vision_proposal?.error) {
    const responseData = camelizeKeys(data.body);
    if (listView) {
      yield put(
        actions.setAdminProjectsList({
          project: { ...responseData, homeownerInterest: responseData.lead?.homeownerInterest },
        }),
      );
    } else {
      yield put(actions.setAdminProjectDetails(responseData));
    }
    if (responseData.linkedProjectId) {
      yield put(actions.setLeadToProposalDrawerLinkedProjectId(responseData.linkedProjectId));
    }
    if (cloneId) {
      yield put(actions.newSuccessEvent({ message: messages.CLONE_VISION_PROPOSAL_SUCCESS }));
      yield put(actions.setAlertMessageVisible({ message: messages.CLONE_VISION_PROPOSAL_SUCCESS }));
    } else {
      yield put(providerLeadsApi.util.invalidateTags([PROJECT_TAGS.PROJECT_ACTIONS, PROJECT_TAGS.PROJECT_PROPOSALS]));
      yield put(actions.newSuccessEvent({ message: messages.REQUEST_ADMIN_VISION_PROPOSAL_SUCCESS }));
      yield put(actions.setLeadToProposalDrawerProposalRequested());
    }
  } else {
    if (requestType === "self-request") put(actions.setCreateVisionReqSuccessful(false));
    return getErrorActions({
      error: error || data.body?.vision_proposal?.error,
      message: messages.ERROR_REQUESTING_ADMIN_PROPOSAL,
    });
  }
  return null;
}

export default requestAdminVisionProposal;
